/**
 * Gordonix arama
 * 1) Marka araması (ORNARTO) → vendor: eşlemesi
 * 2) Model/ölçü (45mm, 41mm, Watch 7) → tüm kritik parçalar başlıkta zorunlu
 * 3) Predictive + arama sayfasında sıkı filtre
 */
(function () {
  var STOP = {
    ve: 1, icin: 1, için: 1, ile: 1, the: 1, and: 1, for: 1, with: 1, uyumlu: 1,
    seri: 1, serisi: 1, model: 1, renk: 1, renkli: 1, kapak: 1, kilif: 1, kılıf: 1
  };

  function norm(s) {
    return String(s || "")
      .toLocaleLowerCase("tr-TR")
      .replace(/ı/g, "i")
      .replace(/İ/g, "i")
      .replace(/\u0307/g, "")
      .replace(/['’]/g, "")
      .trim();
  }

  function tokenize(q) {
    // Barkod / ürün no araması: Shopify sonucu olduğu gibi kalsın
    if (/^\d{8,}$/.test(String(q || "").replace(/[\s-]/g, ""))) return [];
    var raw = norm(q).replace(/vendor:\s*/i, "");
    // 45 mm → 45mm birleşik tut
    raw = raw.replace(/(\d+(?:[.,]\d+)?)\s*mm\b/g, "$1mm");
    raw = raw.replace(/(\d+(?:[.,]\d+)?)\s*inch\b/g, "$1inch");
    var parts = raw.split(/[^a-z0-9.]+/i).filter(Boolean);
    var tokens = [];
    parts.forEach(function (p) {
      if (STOP[p]) return;
      if (p.length < 2 && !/^\d/.test(p)) return;
      tokens.push(p);
    });
    return tokens;
  }

  function criticalTokens(tokens) {
    // ölçü / sayı içeren parçalar kritik
    return tokens.filter(function (t) {
      return /\d/.test(t);
    });
  }

  function haystackOf(p) {
    return norm(
      [p.title, p.vendor, p.product_type, p.handle, (p.tags || []).join(" ")].join(" ")
    ).replace(/(\d+(?:[.,]\d+)?)\s*mm\b/g, "$1mm");
  }

  function productMatchesQuery(p, q) {
    var tokens = tokenize(q);
    if (!tokens.length) return true;
    var hay = haystackOf(p);
    // Kritik sayısal tokenlar (45mm, 7, 41mm...) zorunlu
    var crit = criticalTokens(tokens);
    for (var i = 0; i < crit.length; i++) {
      if (hay.indexOf(crit[i]) === -1) return false;
    }
    // Diğer anlamlı kelimelerin çoğu da geçsin (en az %70)
    var soft = tokens.filter(function (t) {
      return crit.indexOf(t) === -1;
    });
    if (!soft.length) return true;
    var hit = 0;
    soft.forEach(function (t) {
      if (hay.indexOf(t) !== -1) hit++;
    });
    return hit / soft.length >= 0.7;
  }

  function filterProducts(products, q) {
    return (products || []).filter(function (p) {
      return productMatchesQuery(p, q);
    });
  }

  function fetchSuggest(q) {
    return fetch(
      "/search/suggest.json?q=" +
        encodeURIComponent(q) +
        "&resources[type]=product&resources[limit]=50&resources[options][fields]=title,product_type,variants.title,variants.sku,variants.barcode,vendor,tag",
      { credentials: "same-origin", headers: { Accept: "application/json" } }
    )
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        var list =
          (data &&
            data.resources &&
            data.resources.results &&
            data.resources.results.products) ||
          [];
        return filterProducts(list, q);
      });
  }

  function uniqueVendors(products) {
    var set = {};
    products.forEach(function (p) {
      if (p && p.vendor) set[p.vendor] = true;
    });
    return Object.keys(set);
  }

  function isBrandOnlyQuery(q) {
    if (/\d/.test(q)) return false;
    if (/mm\b/i.test(q)) return false;
    var parts = norm(q).split(/\s+/).filter(Boolean);
    return parts.length > 0 && parts.length <= 2;
  }

  function shouldUseVendorSearch(q, products) {
    if (!isBrandOnlyQuery(q) || !products.length) return null;
    var vendors = uniqueVendors(products);
    if (vendors.length !== 1) return null;
    var vendor = vendors[0];
    var qn = norm(q);
    var vn = norm(vendor);
    if (qn === vn || vn.indexOf(qn) !== -1 || qn.indexOf(vn) !== -1) return vendor;
    return null;
  }

  function getQueryFromLocation() {
    return (new URLSearchParams(window.location.search).get("q") || "").trim();
  }

  function textOfCard(el) {
    return norm(el.textContent || el.getAttribute("aria-label") || "");
  }

  function filterDomCards(container, q) {
    if (!container) return;
    var tokens = tokenize(q);
    if (!tokens.length) return;
    var crit = criticalTokens(tokens);
    var cards = container.querySelectorAll(
      "li.predictive-search-results__card--product, li.product-grid__item, .resource-list__item, predictive-search-results__card--product"
    );
    if (!cards.length) {
      cards = container.querySelectorAll("[data-product-id], product-card");
    }
    cards.forEach(function (card) {
      var row =
        card.closest("li") ||
        card.closest(".resource-list__item") ||
        card.closest(".predictive-search-results__card") ||
        card;
      var hay = textOfCard(row).replace(/(\d+(?:[.,]\d+)?)\s*mm\b/g, "$1mm");
      var ok = true;
      for (var i = 0; i < crit.length; i++) {
        if (hay.indexOf(crit[i]) === -1) {
          ok = false;
          break;
        }
      }
      if (ok && tokens.length) {
        var soft = tokens.filter(function (t) {
          return crit.indexOf(t) === -1;
        });
        if (soft.length) {
          var hit = 0;
          soft.forEach(function (t) {
            if (hay.indexOf(t) !== -1) hit++;
          });
          if (hit / soft.length < 0.7) ok = false;
        }
      }
      row.style.display = ok ? "" : "none";
      row.hidden = !ok;
      if (!ok) row.setAttribute("data-gordonix-filtered", "1");
      else row.removeAttribute("data-gordonix-filtered");
    });
  }

  function watchPredictive() {
    var root =
      document.querySelector("predictive-search-component") ||
      document.querySelector("predictive-search") ||
      document.querySelector("[data-testid='search-component--modal']");
    if (!root) return;

    function currentInputQuery() {
      var input =
        root.querySelector('input[name="q"]') ||
        root.querySelector('input[type="search"]') ||
        document.querySelector('input[name="q"]');
      return input ? String(input.value || "").trim() : "";
    }

    var timer = null;
    function apply() {
      var q = currentInputQuery();
      if (!q) return;
      var box =
        root.querySelector("#predictive-search-results") ||
        root.querySelector(".predictive-search-dropdown") ||
        root;
      filterDomCards(box, q);
    }

    var mo = new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(apply, 80);
    });
    mo.observe(root, { childList: true, subtree: true });
    root.addEventListener("input", function () {
      clearTimeout(timer);
      timer = setTimeout(apply, 120);
    }, true);
  }

  async function enhanceSearchPage() {
    if (!/\/search\/?$/.test(window.location.pathname)) return;
    var q = getQueryFromLocation();
    if (!q) return;
    if (/^vendor:/i.test(q)) return;

    var products = [];
    try {
      products = await fetchSuggest(q);
    } catch (e) {
      return;
    }

    var vendor = shouldUseVendorSearch(q, products);
    if (vendor) {
      var url = new URL(window.location.href);
      url.searchParams.set("q", "vendor:" + vendor);
      url.searchParams.set("type", "product");
      if (url.toString() !== window.location.href) {
        window.location.replace(url.toString());
        return;
      }
    }

    // Mevcut grid kartlarını sıkı filtrele
    var grid =
      document.querySelector("results-list") ||
      document.querySelector(".product-grid") ||
      document.querySelector("[data-testid='results-list']");
    filterDomCards(grid || document, q);

    // Sayfa sonucu zayıfsa / 0 ise suggest'ten doldur
    var visible = (grid || document).querySelectorAll(
      "li.product-grid__item:not([hidden]), .product-grid__item:not([style*='display: none'])"
    );
    var visibleCount = 0;
    visible.forEach(function (el) {
      if (el.style.display === "none" || el.hidden) return;
      if (el.getAttribute("data-gordonix-filtered") === "1") return;
      visibleCount++;
    });

    if (products.length && visibleCount < products.length) {
      var target =
        document.querySelector("results-list [ref='grid']") ||
        document.querySelector("results-list ul") ||
        document.querySelector(".product-grid") ||
        grid;
      if (!target) return;

      var empty = document.querySelector(".search-empty, [data-testid='search-empty']");
      if (empty) empty.style.display = "none";

      var have = new Set();
      target.querySelectorAll("[data-product-id]").forEach(function (el) {
        have.add(String(el.getAttribute("data-product-id")));
      });

      products.forEach(function (p) {
        var id = String(p.id || "").replace("gid://shopify/Product/", "");
        if (!id || have.has(id)) return;
        have.add(id);
        var url = p.url || "/products/" + (p.handle || "");
        var img =
          (p.image && (p.image.url || p.image)) ||
          (p.featured_image && (p.featured_image.url || p.featured_image)) ||
          "";
        var li = document.createElement("li");
        li.className = "product-grid__item gordonix-search-suggest-item";
        li.setAttribute("data-product-id", id);
        li.innerHTML =
          '<product-card class="product-card" data-product-id="' +
          id +
          '"><a href="' +
          url +
          '">' +
          (img
            ? '<img src="' +
              String(img).replace(/"/g, "&quot;") +
              '" alt="" loading="lazy" width="400" height="400" style="width:100%;height:auto;object-fit:cover;" />'
            : "") +
          '<h3 style="margin:0.5rem 0 0.25rem;font-size:0.95rem;">' +
          (p.title || "") +
          "</h3></a></product-card>";
        target.appendChild(li);
      });
    }
  }

  function interceptForms() {
    document.addEventListener(
      "submit",
      function (e) {
        var form = e.target;
        if (!(form instanceof HTMLFormElement)) return;
        if (!form.action || form.action.indexOf("/search") === -1) return;
        var input =
          form.querySelector('input[name="q"]') ||
          form.querySelector('input[type="search"]');
        if (!input) return;
        var q = (input.value || "").trim();
        if (!q || /^vendor:/i.test(q)) {
          input.value = q;
          return;
        }
        e.preventDefault();
        fetchSuggest(q)
          .then(function (products) {
            var vendor = shouldUseVendorSearch(q, products);
            var typeInput = form.querySelector('input[name="type"]');
            if (!typeInput) {
              typeInput = document.createElement("input");
              typeInput.type = "hidden";
              typeInput.name = "type";
              form.appendChild(typeInput);
            }
            typeInput.value = "product";
            input.value = vendor ? "vendor:" + vendor : q;
            HTMLFormElement.prototype.submit.call(form);
          })
          .catch(function () {
            input.value = q;
            HTMLFormElement.prototype.submit.call(form);
          });
      },
      true
    );
  }

  interceptForms();
  watchPredictive();
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", enhanceSearchPage);
  } else {
    enhanceSearchPage();
  }
})();
